export enum UnitTypes {
  HEATING = 1,
  COLD_WATER = 2,
  WARM_WATER = 3
}
